// Mood Board Color
export const BG_PRIMARY = '#715A37';
export const BG_SECONDARY = '#DAC4A4';
export const BG_ALTERNATIVE = '#A6A08A';
export const BG_OPACITY = '#50412A';

export const ASSETS_PRIMARY = '#715A37';
// Text Color
export const TEXT_PRIMARY = '#FFECD1';
export const TEXT_SECONDARY = '#DAC4A4';
export const TEXT_ALTERNATIVE = '#171813';

// Music & Navigation Color
export const NAVIGATION_COLOR = '#fcf2e4ff'; // Warna BG
export const ICON_NAVIGATION_COLOR = '#412e11'; // Warna Iconnya
